/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
import {
  IAgentPlugin,
  IPluginMethodMap,
} from "@vlinder-web/plugin-agent-service-react";
import progressBarConfig from "../config/progressBar.config.json";
import selectCostumeConfig from "../config/selectCostume.config.json";
import notificationConfig from "../config/notifications.config.json";
import headerConfig from "../config/header.config.json";
import previewConfig from "../config/preview.config.json";
import paymentConfig from "../config/payment.config.json";
import loadingConfig from "../config/loading.config.json";
import errorConfig from "../config/error.config.json";
import inviteFormData from "../config/inviteUserForm.config.json";
import settingsConfig from "../config/settings.config.json";
import {
  tribeTermsAndConditions,
  pureTermsAndConditions,
  secretsTermsAndConditions,
  calTermsAndConditions,
  hartsTermsAndConditions,
  theLostTribeTermsAndConditions,
  rogueTermsAndConditions,
  blissTermsAndConditions,
  madJouvertTermsAndConditions,
} from "../config/termsAndConditions";

export interface IStaticPageContentMethods extends IPluginMethodMap {
  getStaticPageContentSync(args: any): any;
}

export class StaticPageContentService implements IAgentPlugin {
  readonly methods: IStaticPageContentMethods;

  constructor() {
    this.methods = {
      getStaticPageContentSync: this.getProps.bind(this),
    };
  }

  getProps(args: any) {
    return {
      header: { ...headerConfig },
      progressBar: progressBarConfig,
      selectCostume: selectCostumeConfig,
      preview: previewConfig,
      payment: {
        ...paymentConfig,
        tribeTermsAndConditions,
        pureTermsAndConditions,
        hartsTermsAndConditions,
        secretsTermsAndConditions,
        calTermsAndConditions,
        theLostTribeTermsAndConditions,
        blissTermsAndConditions,
        rogueTermsAndConditions,
        madJouvertTermsAndConditions,
      },
      loading: loadingConfig,
      settings: settingsConfig,
      notifications: notificationConfig,
      inviteFormData: inviteFormData,
      error: errorConfig,
    };
  }
}
